import React from "react";
export default function AlertMessage(props) {
  return (
    <div className={`text-center alert alert-${props.type}`} role="alert">
      {props.message}
    </div>
  );
}
